import React from 'react'
import dynamic from 'next/dynamic'
import { useState, useEffect } from 'react'

import { makeStyles, Container, Paper } from '@material-ui/core'
import Layout from '../components/common/Layout'
import NewShell from '../components/pages-new/NewShell'
import MascotBox from '../components/common/MascotBox/MascotBox'
import PdpaUtility from '../components/utility/pdpaUtility'
import ConsentUpdateDetail from '../components/common/ConsentUpdateDetail'

import LegalStyleDiv from '../components/common/Consents/LegalStyleDiv'
import LegalOrderingDiv from '../components/common/Consents/LegalOrderingDiv'
import LegalBodyDiv from '../components/common/Consents/LegalBodyDiv'

import { useRouter } from 'next/router'

const PdpaPopup = dynamic(() =>
  import('../components/common/PdpaPopup/PdpaPopup')
)

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
  },
  page: {
    width: '100vw',
    flexGrow: 1,
    padding: '20px 0',
  },
  paper: {
    width: '100%',
    padding: 20,
    '& > :not(h1)': {
      fontFamily: 'Helvetica, sans-serif',
    },
    '& > h1': {
      color: theme.palette.primary.main,
      textAlign: 'center',
    },
  },
  orderList: {
    counterReset: 'item',
  },
  list: {
    display: 'block',

    '&:before': {
      content: 'counters(item, ".") ". "',
      counterIncrement: 'item',
    },
  },
  toRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  highlight: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  oderContainer: {
    '& > ol': {
      padding: '0',
    },
  },
}))

const TabSpace = () => {
  return <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
}

const Privacy = ({ isNew }) => {
  const classes = useStyles()

  const Router = useRouter()
  const language = Router.locale

  const isEnglish = language === 'en'

  const trans = (engText, thaiText) => {
    return language === 'en' ? engText : thaiText
  }

  const [isPdpaShowing, setPdpaShowing] = useState(false)
  const [editCookiesMode, setEditCookiesMode] = useState(false)
  const [pdpaStates, setPdpaStates] = useState({
    isSetPdpa: false,
    allowTargeting: false,
    allowFunctionality: false,
    allowPerformance: false,
  })

  const setPdpa = ({ targeting, functionality, performance }) => {
    // set pdpa by save setting
    setPdpaStates({
      ...pdpaStates,
      allowTargeting: targeting,
      allowFunctionality: functionality,
      allowPerformance: performance,
    })

    if (localStorage.getItem('jwt_token')) {
      PdpaUtility.setPdpaLocalStorage({ targeting, functionality, performance })
      PdpaUtility.setPdpaCookies(true, {
        targeting,
        functionality,
        performance,
      })
      PdpaUtility.updatePdpaMemberService({
        targeting,
        functionality,
        performance,
      })
    } else {
      PdpaUtility.setPdpaCookies(false, {
        targeting,
        functionality,
        performance,
      })
    }
  }

  const handleClickSetCookies = () => {
    setPdpaShowing(true)
    setEditCookiesMode(true)
  }

  const META = {
    title: 'นโยบายคุ้มครองความเป็นส่วนตัว (Privacy Policy) - SHIPPOP',
    keywords: 'นโยบาย, ความคุ้มครอง, ความเป็นส่วนตัว, PDPA',
    description: 'นโยบายคุ้มครองความเป็นส่วนตัว (Privacy Policy) - SHIPPOP',
  }

  // CONTENT identical for both variants; only the chrome differs.
  const content = (
      <>
        <div className={classes.page}>
          <Container>
            <Paper elevation={3} className={classes.paper}>
              <h1>
                {trans(
                  'Privacy Policy',
                  'นโยบายความเป็นส่วนตัว (Privacy Policy)'
                )}
              </h1>
              <>
                {/* เริ่มย่อหน้าแรก */}
                {isEnglish && (
                  <p>
                    SHIPPOP COMPANY LIMITED (“<strong>SHIPPOP</strong>” or “
                    <strong>We</strong>”) recognizes the importance of your
                    personal information and privacy, as well as that of those
                    who are under your supervision. Therefore, this Privacy
                    Policy is meant to explain our practices regarding the
                    collection, use or disclosure of personal data, as well as
                    other rights of the data subject under the Personal Data
                    Protection Law (“
                    <strong>PDPA</strong>”). This Privacy Policy is only
                    intended to cover your personal data collected from the use
                    of our services or the platforms controlled by us,
                    regardless of the country or region where our services are
                    being provided.
                  </p>
                )}
                {!isEnglish && (
                  <p>
                    <TabSpace />
                    บริษัท ชิปป๊อป จำกัด (“<strong>ชิปป๊อป</strong>” หรือ “
                    <strong>เรา</strong>“)
                    ให้ความสำคัญกับการคุ้มครองความเป็นส่วนตัวและข้อมูลส่วนบุคคลของท่านและบุคคลที่อยู่ในความดูแลหรืออำนาจปกครองของท่านเป็นอย่างยิ่ง
                    เราจึงได้จัดทำนโยบายความเป็นส่วนตัวฉบับนี้เพื่ออธิบายแนวปฏิบัติเกี่ยวกับการเก็บรวบรวม
                    ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล (Personal Data) ของเรา
                    รวมถึงสิทธิต่าง ๆ
                    ของเจ้าของข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
                    โดยนโยบายความเป็นส่วนตัวฉบับนี้จะครอบคลุมถึงข้อมูลที่เราได้รับจากท่านผ่านการใช้บริการของเราหรือแพลตฟอร์มที่ถูกควบคุมโดยเราเท่านั้นโดยไม่คำนึงถึงประเทศหรือภูมิภาคที่เราให้บริการ
                  </p>
                )}
                {/* จบย่อหน้าแรก */}
                {/* เริ่มย่อหน้าสอง */}
                {isEnglish && (
                  <p>
                    This Privacy Policy (“<strong>Privacy Policy</strong>”)is
                    considered as part of the Term of Use. Please read this
                    Privacy Policy carefully to understand our policies and
                    practices regarding your personal data and the method we use
                    with your personal data before using this website or
                    application. Getting access to our platforms or using our
                    services means that you understand and accept this Privacy
                    Policy.
                  </p>
                )}
                {!isEnglish && (
                  <p>
                    <TabSpace />
                    นโยบายความเป็นส่วนตัวนี้ถือเป็นส่วนหนึ่งของเงื่อนไขการใช้บริการ
                    กรุณาศึกษาเกี่ยวกับโยบายความเป็นส่วนตัวฉบับนี้อย่างรอบคอบก่อนเข้าใช้บริการเพื่อทำความเข้าใจนโยบายและแนวทางปฏิบัติของเราเกี่ยวกับข้อมูลส่วนบุคคลของท่านและวิธีที่เราใช้เพื่อปฏิบัติต่อข้อมูลดังกล่าว
                    สำหรับการใช้บริการหรือการเข้าถึงแพลตฟอร์มของเราในแต่ละครั้งจะถือว่าท่านได้อ่านและตกลงยอมรับนโยบายความเป็นส่วนตัวนี้แล้ว
                  </p>
                )}
                {/* จบย่อหน้าสอง */}
                {/* เริ่มย่อหน้าสาม */}
                {isEnglish && (
                  <p>
                    This Privacy Policy is written in English and Thai language.
                    In the event of conflict or discrepancy between English and
                    Thai language, the Thai language shall prevail over.
                  </p>
                )}
                {/* จบย่อหน้าสาม */}
                {/* เริ่มหัวข้อที่1 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>1.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Collection of Personal Data',
                        'การเก็บรวบรวมข้อมูลส่วนบุคคล'
                      )}
                    </strong>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>1.1</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>
                          <span>
                            {trans(
                              `Person Whom We Collect Personal Data`,
                              `บุคคลที่เราเก็บรวบรวมข้อมูลส่วนบุคคลส่วนบุคคล`
                            )}
                          </span>
                        </p>
                        <p>
                          <span>
                            {trans(
                              `Under this Privacy Policy, we will collect and process personal data from the individuals listed below.`,
                              `ภายใต้นโยบายความเป็นส่วนตัวฉบับนี้ เราจะเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของบุคคลดังต่อไปนี้`
                            )}
                          </span>
                        </p>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>1)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `Our customers, including, but not limited to, those who purchase our goods and/or use our services, those who purchase goods or use the services from us, our registered members, participants in our activities, visitors of any of our existing or future channels, or any other persons having similar characteristics.`,
                                `ผู้ใช้บริการหรือลูกค้าของเราซึ่งได้แก่บุคคลที่ใช้บริการหรือซื้อสินค้าของเราหรือจากเรา ผู้แสดงความสนใจในบริการหรือสินค้าของเรา ผู้ลงทะเบียนเป็นสมาชิก ผู้เข้าร่วมกิจกรรมซึ่งจัดโดยเรา บุคคลผู้เข้าชม ติดต่อหรือใช้งานช่องทางที่มีอยู่ในปัจจุบันหรืออาจมีขึ้นในอนาคตของเราซึ่งรวมถึงแต่ไม่จำกัดเพียงการใช้บริการของเราผ่านเว็บไซต์ www.shippop.com แอปพลิเคชัน และบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>2)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `Directors, employees, contact persons, legal representatives, or authorized persons of our corporate customers. In this case, we recommend our corporate customer to ensure that such persons have acknowledged this Privacy Policy.`,
                                `กรรมการ พนักงาน บุคคลติดต่อ ผู้รับมอบอำนาจหรือมีอำนาจกระทำการแทนนิติบุคคลของลูกค้าหรือผู้ใช้บริการ ในกรณีที่ผู้ใช้บริการหรือลูกค้าเป็นนิติบุคคล และให้รวมถึงผู้ที่ข้อมูลส่วนบุคคลปรากฏในเอกสารต่าง ๆ ที่เกี่ยวข้องกับความสัมพันธ์ระหว่างท่านกับเรา โดยในกรณีนี้เราขอแนะนำให้ท่านดำเนินการให้บุคคลที่เกี่ยวข้องดังกล่าวรับทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>3)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `Individuals who are not our customers, but we need to collect and process personal data of such persons in order to carry out transactions between us and our customers. Such persons may include a consignee, a sender, etc.`,
                                `บุคคลซึ่งไม่ใช่ผู้ใช้บริการหรือลูกค้าของเราโดยตรง แต่เรามีความจำเป็นต้องเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของบุคคลดังกล่าวเนื่องจากบุคคลดังกล่าวเกี่ยวข้องกับการทำธุรกรรมระหว่างท่านกับเรา เช่น ผู้รับพัสดุ ผู้นำส่งพัสดุ เป็นต้น`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>1.2</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>
                          <span>
                            {trans(
                              `Type of Collected Personal Data`,
                              `ประเภทของข้อมูลส่วนบุคคลที่เราเก็บรวบรวม`
                            )}
                          </span>
                        </p>
                        <p>
                          <span>
                            {trans(
                              `Your personal data which we will collect includes the following:`,
                              `เรามีความจำเป็นต้องจัดเก็บรวบรวมข้อมูลส่วนบุคคลของท่านดังต่อไปนี้`
                            )}
                          </span>
                        </p>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>1)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `identification data such as name, surname, photograph, gender, identification card, age, and passport;`,
                                `ข้อมูลที่สามารถระบุถึงตัวบุคคล เช่น ชื่อสกุล รูปถ่าย เพศ บัตรประจำตัวประชาชน อายุ หนังสือเดินทาง`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>2)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `business information such as shop name, shop logo;`,
                                `ข้อมูลเกี่ยวกับร้านค้า เช่น ชื่อร้านค้า โลโก้ร้านค้า`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>3)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `contact information such as phone number, e-mail, address, place of residence and place of work;`,
                                `ข้อมูลในการติดต่อ เช่น หมายเลขโทรศัพท์  อีเมล ที่อยู่ สถานที่พักอาศัย สถานที่ทำงาน`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>4)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `parcel and insurance information such as shipment information, parcel number, consignment, amount delivered parcel;`,
                                `ข้อมูลพัสดุและประกันพัสดุ เช่น ข้อมูลการสร้างรายการขนส่ง หมายเลขพัสดุ ใบปะหน้าพัสดุ ใบจัดส่งสินค้า/พัสดุ ยอดพัสดุ`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>5)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `payment information such as bank account information, bankbook, credit card number, COD amount, payment receipt;`,
                                `ข้อมูลเกี่ยวกับการชำระเงิน เช่น ข้อมูลบัญชีธนาคาร หน้าบัญชีธนาคาร หมายเลขบัตรเครดิต ยอดเก็บเงินปลายทาง ใบเสร็จรับเงิน`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>6)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `information relating to your access or use of our services/platforms such as IP address, Cookies;`,
                                `ข้อมูลเกี่ยวกับการเข้าถึงหรือการใช้บริการและแพลตฟอร์มของชิปป๊อป เช่น หมายเลขไอพี คุกกี้ `
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>7)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `information provided, sent, or uploaded by you through our platforms such as user name, password, e-mail, data files;`,
                                `ข้อมูลที่ท่านแจ้ง กรอก ส่ง หรืออัพโหลดแก่เรา เช่น ชื่อบัญชีผู้ใช้ (User Name) รหัสผ่าน (Passcode) อีเมล (Email Address) ไฟล์ข้อมูลปลายทาง`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>8)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `social media account information (in case your user account is registered with your Facebook account);`,
                                `ข้อมูลบัญชีโซเชียลมีเดียอื่น ๆ ในกรณีที่ท่านสร้างบัญชีผู้ใช้ผ่านบัญชีโซเชียลมีเดียดังกล่าว เช่น Facebook`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>9)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `information that associates with our platforms such as browser type, domain name, a web page that you accessed, access time, and referring websites address, and geographic data;`,
                                `ข้อมูลที่เชื่อมโยงกับแพลตฟอร์มของเรา เช่น ชนิดของโปรแกรมค้นผ่าน (Browser Type) โดเมนเนม (Domain Name) บันทึกหน้าเว็บ (Web Page) ของเว็บไซต์ที่ผู้ใช้เยี่ยมชม เวลาที่เยี่ยมชมเว็บไซต์ (Access Times) และเว็บไซต์ที่ผู้ใช้บริการเข้าถึงก่อนหน้านั้น (Referring Website Addresses) ข้อมูลทางภูมิศาสตร์ `
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>10)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `your feedback related to our services.`,
                                `ข้อแนะนำหรือความคิดเห็นของท่าน`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>11)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `Any other information of the owner of personal data in the same manner as Personal Data Protection Commission announces.`,
                                `ข้อมูลอื่นใดของเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่ คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>{isEnglish ? '1.3' : <>&nbsp;&nbsp;&nbsp;</>}</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>
                          <span>
                            {trans(
                              `Source of Personal Data`,
                              `โดยเราได้เก็บรวบรวมข้อมูลส่วนบุคคลข้างต้นจากช่องทางที่หลากหลายดังต่อไปนี้`
                            )}
                          </span>
                        </p>
                        {isEnglish && (
                          <p>
                            We may collect your personal data from a variety of
                            sources, including:
                          </p>
                        )}
                        <LegalStyleDiv>
                          <LegalOrderingDiv>1)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {trans(
                                `account or membership registration, filling or submitting information  through our websites, applications, or other channels;`,
                                `การกรอกข้อมูล การส่งเอกสาร การลงทะเบียนหรือการสมัครสมาชิกผ่านช่องทางของเราทั้งแบบออนไลน์และออฟไลน์`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>2)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {trans(
                                `your access and use of our website or applications which include cookies and other internet tracking software;`,
                                `การใช้งานและการเยี่ยมชมของท่านผ่านระบบ เว็บไซต์หรือแอปพลิเคชันของเรา รวมถึงการใช้คุกกี้หรือโปรแกรม tracking อื่นๆ ในการเก็บรวบรวมข้อมูลส่วนบุคคล`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>3)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {' '}
                              {trans(
                                `purchasing our products and/or using our services through our online or offline platform;`,
                                `การซื้อสินค้า และ/หรือ การใช้บริการของเราทั้งแบบออนไลน์และออฟไลน์`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>4)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {trans(
                                `contracts, agreements, or other documents having similar nature  between you and us;`,
                                `การทำธุรกรรม สัญญา ข้อตกลง หรือเอกสารต่าง ๆ ในลักษณะเดียวกันระหว่างท่านกับเรา`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>5)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {trans(
                                `conversation in any form including call records, e-mails, notes and other means`,
                                `การสนทนาและบันทึกการสนทนาในรูปแบบต่าง ๆ ระหว่างท่านกับเราเพื่อสอบถามข้อมูล การบริการ หรือการช่วยเหลือด้านการใช้งาน`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>6)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {trans(
                                `package claims or insurance;`,
                                `การเคลมพัสดุหรือการทำประกันพัสดุ`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>7)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {trans(
                                `a third party including our business partners, service providers, or public resource;`,
                                `ข้อมูลที่ได้รับจากบุคคลภายนอก เช่น ผู้ให้บริการด้านต่าง ๆ แก่เรา คู่ค้าทางธุรกิจของเรา แหล่งข้อมูลสาธารณะที่มีข้อมูลเกี่ยวกับธุรกิจของท่าน`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>8)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {trans(
                                `your Facebook ID registration, which requires you to enter your Facebook password (We will not collect or store such a password.);`,
                                `การเชื่อมกับต่อกับ Facebook ซึ่งเราอาจขอให้ท่านป้อนรหัสผ่าน Facebook ของท่าน โดยเราจะไม่เก็บรวบรวมหรือจัดเก็บรหัสผ่านดังกล่าว`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>9)</LegalOrderingDiv>
                          <LegalBodyDiv multiply={1}>
                            <span>
                              {trans(
                                `customer Survey;`,
                                `แบบสำรวจความเห็นของลูกค้า`
                              )}
                            </span>
                          </LegalBodyDiv>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>10)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `your participation in our promotional campaigns or marketing activities;`,
                                `การเข้าร่วมการแข่งขันหรือการส่งเสริมการตลาดของเรา`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>11)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `our advertisement activities;`,
                                `การโฆษณาและการประชาสัมพันธ์สินค้าหรือบริการของเราผ่านช่องทางออนไลน์และออฟไลน์`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                        <LegalStyleDiv>
                          <LegalOrderingDiv>12)</LegalOrderingDiv>
                          <div>
                            <span>
                              {trans(
                                `any of our current or future channels.`,
                                `ช่องทางอื่นใดของเราที่มีอยู่ในปัจจุบันหรืออาจมีขึ้นในอนาคต`
                              )}
                            </span>
                          </div>
                        </LegalStyleDiv>
                      </div>
                    </LegalStyleDiv>
                    <p>
                      {trans(
                        `By providing personal data of a person related to you such as your directors, employee, contact person, you represent that you have the right to provide personal data of such person and you have informed such person of this Privacy Policy. `,
                        `ในกรณีท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่เกี่ยวข้องกับท่าน เช่น กรรมการ พนักงาน บุคคลติดต่อ ท่านรับรองว่าท่านได้แจ้งให้บุคคลดังกล่าวทราบถึงนโยบายความเป็นส่วนตัวนี้และท่านมีสิทธิในการให้ข้อมูลส่วนบุคคลดังกล่าว รวมทั้งอนุญาตให้เราใช้ข้อมูลส่วนบุคคลดังกล่าวภายใต้นโยบายความเป็นส่วนตัวนี้`
                      )}
                    </p>
                    <p>
                      {trans(
                        `We recommend that you review the privacy policy of other third parties, websites or channels that are linked to these websites or applications, to acknowledge and understand how they collect, use or disclose your personal data. We cannot endorse or warrant any statement or actions as announced by such third parties, websites or channels and will not be responsible for any operation or proceed that does not comply with the privacy policy of such third parties, websites or channels.`,
                        `สำหรับข้อมูลที่เก็บรวบรวมจากท่านผ่านบุคคลที่สาม เว็บไซต์ หรือช่องทางอื่นใดที่เรามิได้เป็นผู้จัดทำ เราขอแนะนำให้ท่านตรวจสอบนโยบายความเป็นส่วนตัว (Privacy Policy) ของบุคคล เว็บไซต์หรือช่องทางดังกล่าวเพื่อจะได้ทราบและเข้าใจเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน โดยเราไม่สามารถรับรองข้อความหรือรับรองการดำเนินการใด ๆ ตามที่ได้มีการประกาศไว้โดยบุคคล เว็บไซต์หรือช่องทางดังกล่าวได้ และเราไม่มีความรับผิดชอบใด ๆ หากบุคคลที่สาม เว็บไซต์หรือช่องทางเหล่านั้นไม่ได้ดำเนินการตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลที่ได้ประกาศไว้`
                      )}
                    </p>
                    <p>
                      {trans(
                        `Please acknowledge that if you are unable to provide certain types of personal data when requested, we may not be able to carry out our legal obligations or enter into an agreement with you, or you may be unable to use our services or platforms in whole or in part, or you may not receive full benefit from us.`,
                        `ทั้งนี้ ในกรณีที่ท่านไม่ประสงค์หรือไม่สามารถให้ข้อมูลบางประเภทแก่เรา เราอาจไม่สามารถเข้าทำสัญญากับท่านได้หรือไม่สามารถปฏิบัติหน้าที่มีต่อท่านได้ หรือท่านอาจไม่สามารถใช้บริการหรือแพลตฟอร์มของชิปป๊อปได้ทั้งหมดหรือบางส่วนแล้วแต่กรณี หรือท่านอาจไม่ได้รับสิทธิประโยชน์จากเราได้อย่างเต็มที่`
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่1 */}
                {/* เริ่มหัวข้อที่2 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>2.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans('Use of Personal Data', 'การใช้ข้อมูลส่วนบุคคล')}
                    </strong>
                    <p>
                      {' '}
                      {trans(
                        `We will collect, store, share, update, process, and use the personal information mentioned above under the Term of Use, this Privacy Policy, applicable law, and your consent.  For instance, we may process your personal data for the following purposes:`,
                        'เราจะรวบรวม เก็บรักษา อัพเดท แบ่งปัน ประมวลผล และใช้ข้อมูลต่าง ๆ ข้างต้นเพียงเท่าที่จำเป็นภายใต้เงื่อนไขการใช้บริการ นโยบายความเป็นส่วนตัวฉบับนี้ กฎหมาย และความยินยอมของท่านเพื่อวัตถุประสงค์ดังต่อไปนี้'
                      )}
                    </p>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>1)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          'conducting an identity authentication and verification, as well as conducting an account registration;',
                          'เพื่อใช้ในการพิสูจน์และยืนยันตัวตน รวมทั้งการลงทะเบียนบัญชีผู้ใช้งาน'
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>2)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          'processing your request prior to entering into an agreement and/or in order to perform obligations under a contract to which you are a party, or providing our services to you. For example, we will use your personal data to provide parcel delivery services or parcel insurance services by our courier partners to you, as well as to proceed your damages claim request;',
                          'เพื่อใช้ในการดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญาหรือปฏิบัติหน้าที่ตามสัญญาที่มีต่อท่านหรือการให้บริการของเรา เช่น การให้บริการรวบรวมผู้ให้บริการขนส่งและจัดส่งพัสดุโดยผู้ให้บริการขนส่งที่เป็นพาร์ทเนอร์ของเรา การชำระเงินค่าบริการ การให้บริการประกันพัสดุและการเคลมพัสดุ การเช็คสถานะพัสดุ'
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>3)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          'performance of our task in order to carry out the public interest, or for the purpose of exercising of official authority;',
                          'เพื่อการปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์สาธารณะของเราหรือปฏิบัติหน้าที่ในการใช้อำนาจรัฐที่ได้มอบให้แก่เรา'
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>4)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          'legitimate interests pursued by us or by a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of yours, such as investigating and preventing any illegal activity, counting our business management, or ensuring security in our services and systems;',
                          'เพื่อประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลอื่น เว้นแต่ประโยชน์ดังกล่าวมีความสำคัญน้อยกว่าสิทธิขั้นพื้นฐานในข้อมูลส่วนบุคคลของท่าน เช่น การตรวจสอบและป้องกันการกระทำที่ผิดกฎหมาย การบริหารจัดการธุรกิจของเรา การป้องกันและดูแลรักษาความปลอดภัยของบริการหรือระบบของเรา'
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>5)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          'establishment, compliance, exercise, or defense of legal claims, such as compliance with narcotics prevention and suppression measures under the Narcotics Prevention and Suppression Act, B.E. 2519 (1976);',
                          'เพื่อก่อตั้งสิทธิเรียกร้องตามกฎหมาย การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย หรือการยกขึ้นต่อสู้ตามกฎหมาย เช่น การปฏิบัติตามมาตรการป้องกันและปราบปรามยาเสพติดตามพระราชบัญญัติป้องกันและปราบปรามยาเสพติด พ.ศ. 2519'
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>6)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          'contacting you for providing information, customer services, help support, as well as responding to any of your inquiries;',
                          'เพื่อการติดต่อ การสอบถามข้อมูล การดูแลลูกค้า หรือการช่วยเหลือด้านการใช้งาน'
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>7)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          'providing convenience for you and processing your request, including offering a searching location of our service points, preparing service report, and prefill on our login page;',
                          'เพื่ออำนวยความสะดวกแก่ท่านและการปฏิบัติตามคำร้องขอของท่าน เช่น การค้นหาจุดบริการส่งพัสดุ การเข้าระบบหรือการใช้บริการโดยไม่ต้องกรอกข้อมูลซ้ำ การจัดทำรายงานต่าง ๆ'
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          'organizing our public relations and marketing activities, promotional campaigns or events, such as sending our marketing materials to you through various channels;',
                          'เพื่อการนำเสนอข้อมูล การประชาสัมพันธ์ การส่งเสริมการขายหรือกิจกรรมทางการตลาด เช่น การส่งข่าวสาร การประชาสัมพันธ์บริการหรือสินค้า โปรโมชั่นและสิทธิพิเศษของเรา'
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>9)</LegalOrderingDiv>
                      <LegalBodyDiv multiply={1}>
                        {trans(
                          `research, analysis, survey, discrimination and forecasting of statistical, marketing, and behavioral related to business or relevant activities data and related behavior in business or related activities (Marketing and Data Analysis), which allows us to truly fulfill your needs;`,
                          `เพื่อการวิจัย การวิเคราะห์ การสํารวจ การแยกแยะและคาดการณ์ข้อมูลทั้งในเชิงสถิติ การตลาด และพฤติกรรมที่เกี่ยวข้องในกิจการหรือกิจกรรมที่เกี่ยวข้อง (Marketing and Data Analysis) ซึ่งทำให้เรารู้จักท่านมากขึ้นและตอบสนองความต้องการของท่านได้อย่างถูกต้อง`
                        )}
                      </LegalBodyDiv>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>10)</LegalOrderingDiv>
                      <div>
                        {trans(
                          'improving our management efficiency, quality control, business development, product development, and systems;',
                          'เพื่อเพิ่มประสิทธิภาพในการจัดการ ควบคุมคุณภาพและพัฒนาธุรกิจ สินค้า บริการ และระบบของเราและเพื่อพัฒนาผลิตภัณฑ์ของเราให้ดียิ่งขึ้น'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>11)</LegalOrderingDiv>
                      <div>
                        {trans(
                          'our reorganization, merger, sale, transfer, investment or similar event, in which your personal data is required to be disclosed and transferred to any third party  as part of that transaction;',
                          'เพื่อการปรับโครงสร้างองค์กร การควบรวม การขายกิจการ การถ่ายโอนธุรกิจหรือสินทรัพย์อื่น ๆ การลงทุนในธุรกิจของเรา และการกระทำอื่น ๆ ในลักษณะเดียวกัน ในกรณีที่การเปิดเผยและการโอนข้อมูลส่วนบุคคลของท่านเป็นส่วนหนึ่งของการทำธุรกรรมนั้น'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>12)</LegalOrderingDiv>
                      <div>
                        {trans(
                          'other purposes subject to applicable laws such as preventing or suppressing a danger to a Person’s life, body or health.',
                          'เพื่อดำเนินการภายใต้วัตถุประสงค์อื่น  ๆ ที่กฎหมายอนุญาต เช่น วัตถุประสงค์ในการป้องกันหรือระงับอันตรายต่อชีวิต  ร่างกาย  หรือสุขภาพของบุคคล เป็นต้น'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>13)</LegalOrderingDiv>
                      <div>
                        {trans(
                          "For the purpose of allowing you to receive offers or provide products, services and the Company's objectives. or benefits that are appropriate for you We will have research. Prepare statistical data, analyze or develop such products, services and benefits.",
                          'เพื่อวัตถุประสงค์ให้ท่านได้รับการเสนอหรือจัดให้มีผลิตภัณฑ์ บริการ และวัตถุประสงค์ของบริษัท หรือสิทธิประโยชน์ที่เหมาะสมแก่ท่าน เราจะมีการวิจัย ทำข้อมูลสถิติ วิเคราะห์ หรือพัฒนาผลิตภัณฑ์ บริการ และสิทธิประโยชน์ดังกล่าว'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>14)</LegalOrderingDiv>
                      <div>
                        {trans(
                          "For marketing purposes, we may disclose your personal information and any information to the Company's affiliated companies and trusted business partners, including affiliated companies and insurance business group, namely TQM Alpha Public Company Limited, for the purpose of offering or providing products and services, and providing services and benefits to you. By doing so, the Company's affiliated companies and trusted business partners will conduct research, analyze statistical data, or develop products, services, and benefits that are appropriate for you.",
                          'เพื่อวัตถุประสงค์ทางการตลาด เราอาจเปิดเผยข้อมูลส่วนบุคคลและข้อมูลใดๆ ของท่าน ให้แก่บริษัทในเครือธุรกิจและพันธมิตรทางธุรกิจที่เชื่อถือได้ของบริษัท ได้แก่กลุ่มบริษัทในเครือ และกลุ่มธุรกิจประกันภัย คือ บริษัท ทีคิวเอ็ม อัลฟา จำกัด (มหาชน)                        เพื่อวัตถุประสงค์ในการเสนอหรือจัดให้มีผลิตภัณฑ์บริการ และการให้บริการและสิทธิประโยชน์แก่คุณ โดยการดำเนินการดังกล่าว บริษัทในเครือธุรกิจ และพันธมิตรทางธุรกิจที่เชื่อถือได้ของบริษัท จะมีการวิจัย ทำข้อมูลสถิติวิเคราะห์ หรือพัฒนาผลิตภัณฑ์ บริการ และสิทธิต่างๆประโยชน์ที่เหมาะสมแก่คุณ'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <p>
                      {' '}
                      {trans(
                        `You may be required to submit an image or a copy of your ID card for the purpose of conducting an identity authentication and verification, which may allow us to obtain your sensitive data that we do not intend to collect and process, such as religious data, which is not necessary for our purpose. To maintain your privacy, you may conceal such sensitive data before disclosing any materials containing such sensitive data.`,
                        'ในบางกรณีเราจำเป็นต้องขอให้ท่านส่งภาพถ่ายหรือสำเนาบัตรประชาชนเพื่อดำเนินการพิสูจน์และยืนยันตัวตน ซึ่งอาจทำให้เราได้รับข้อมูลส่วนบุคคลที่มีความอ่อนไหวที่ไม่มีความจำเป็นต่อการดำเนินการเพื่อให้บรรลุวัตถุประสงค์ของเรา เช่น ข้อมูลศาสนาบนบัตรประชาชน เป็นต้น โดยเราขอแจ้งให้ท่านทราบว่าท่านมีสิทธิปิดทับข้อมูลดังกล่าวออกก่อนเปิดเผยข้อมูล และเราไม่มีเจตนาเก็บและประมวลผลข้อมูลส่วนบุคคลที่มีความอ่อนไหวนั้นแต่อย่างใด'
                      )}
                    </p>
                    <p>
                      {' '}
                      {trans(
                        `We may ask for your consent to process your personal data in accordance with applicable laws. In case we collect, store, update, share, process and use your personal data other than the above purposes, we will update this Privacy Policy and we will seek your additional consent if necessary.`,
                        `หากเราจำเป็นต้องได้รับความยินยอมจากท่านเพื่อประมวลผลข้อมูลส่วนบุคคล เราจะดำเนินการขอความยินยอมจากท่านก่อนหรือในขณะที่มีการประมวลผลข้อมูลส่วนบุคคลดังกล่าวภายใต้เงื่อนไขที่กฎหมายกำหนด และหากเราจะรวบรวม เก็บรักษา อัพเดท แบ่งปัน ประมวลผล และใช้ข้อมูลส่วนบุคคลของท่านนอกเหนือจากวัตถุประสงค์ข้างต้น เราจะดำเนินการปรับปรุงนโยบายความเป็นส่วนตัวนี้และในกรณีที่จำเป็นเราจะดำเนินการขอความยินยอมจากท่านเพิ่มเติม`
                      )}
                    </p>
                    <p>
                      {' '}
                      {trans(
                        `In the event that the data subject is under the age of majority and incapable of entering into and performing legally binding contracts under Thai laws, the parent or guardian of such person must grant consent for processing the personal data of such person.`,
                        `ทั้งนี้ ในกรณีที่เจ้าของข้อมูลส่วนบุคคลยังไม่บรรลุนิติภาวะและไม่มีความสามารถในการเข้าทำนิติกรรมบิดามารดาหรือผู้ปกครองของบุคคลดังกล่าวจะต้องเป็นผู้ให้ความยินยอมในการใช้ข้อมูลส่วนบุคคลนั้น`
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่2 */}
                {/* เริ่มหัวข้อที่3 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>3.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Disclosure of Personal Data',
                        'การเปิดเผยข้อมูลส่วนบุคคล'
                      )}
                    </strong>
                    <p>
                      {' '}
                      {trans(
                        `We may disclose your personal data with your consent or as permitted by law to the following parties in certain circumstances.`,
                        'เราอาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่ผู้อื่นภายใต้ความยินยอมของท่านหรือที่กฎหมายอนุญาตให้เปิดเผยได้ ดังต่อไปนี้'
                      )}
                    </p>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>3.1</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>
                          {trans(
                            `Internal Organization`,
                            `การบริหารจัดการภายในองค์กร`
                          )}
                        </p>
                        <p>
                          {trans(
                            `We may disclose your personal data within our organization, including our directors, executive officers, staff, employees and personnel, to process your personal data for the aforementioned purposes.`,
                            `เราอาจเปิดเผยข้อมูลส่วนบุคคลของท่านเท่าที่จำเป็นเพื่อดำเนินการตามวัตถุประสงค์ที่กำหนดไว้ข้างต้นแก่บุคคลภายในบริษัทซึ่งรวมถึงผู้บริหาร กรรมการ พนักงาน ลูกจ้าง และ/หรือบุคลากร`
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>3.2</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>{trans(`Service Providers`, `ผู้ให้บริการ`)}</p>
                        <p>
                          {trans(
                            `We may disclose your personal data, as necessary, to our service providers or contractors to conduct our business operations such as telecommunication service, data storage service, IT supports, bank and payment service, transportation service, accounting and financial service, marketing and product service, insurance services, business development service, audit service and other services that provide benefit to you.`,
                            `เท่าที่จำเป็นเพื่อดำเนินงานในด้านต่าง ๆ ในธุรกิจของเรา เช่น การโทรคมนาคม การจัดเก็บข้อมูล การให้บริการด้านเทคโนโลยี การชำระเงินและระบบการชำระเงิน โลจิสติกส์ การขนส่งพัสดุ การจัดซื้อจัดจ้าง การเงินและการบัญชี การตลาด ประกันภัย การพัฒนาสินค้าหรือบริการ ผู้สอบบัญชี หรือบริการอื่นใดที่เป็นประโยชน์แก่ท่าน เป็นต้น `
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>3.3</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>
                          {trans(
                            `Business Partners`,
                            `คู่ค้าและพันธมิตรทางธุรกิจ `
                          )}
                        </p>
                        <p>
                          {trans(
                            `In relation with our business partners such as logistic partners and insurance partners, we may disclose certain personal data to them in order to coordinate and provide our services and privileges to you. However, we will only provide them with the information on a need-to-know basis.`,
                            `เราอาจเปิดเผยข้อมูลบางอย่างกับคู่ค้าและพันธมิตรทางธุรกิจ เช่น ผู้ให้บริการด้านโลจิสติกส์หรือด้านประกันภัยที่เป็นพันธมิตรกับเราเพื่อการติดต่อประสานงาน การให้บริการต่าง ๆ และการให้สิทธิประโยชน์ต่าง ๆ แก่ท่าน โดยเราจะเปิดเผยขอมูลส่วนบุคคลของท่านให้แก่บุคคลดังกล่าวบนพื้นฐานเรื่องที่ต้องรู้`
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>3.4</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>{trans(`Business Transfer`, `การถ่ายโอนธุรกิจ`)}</p>
                        <p>
                          {trans(
                            `In connection with any reorganization, restructuring, merger or acquisition, or other transfer of assets, we may transfer your personal data to a third party as part of the transaction, provided that the receiving party agrees to respect your personal data in a manner that is consistent with this Privacy Policy and the Personal Data Protection Law.`,
                            `เราอาจเปิดเผยข้อมูลรวมถึงข้อมูลส่วนบุคคลของท่านสำหรับการปรับโครงสร้างองค์กร การควบรวมหรือการขายกิจการ หรือการถ่ายโอนสินทรัพย์อื่น ๆ โดยฝ่ายที่รับโอนต้องปฏิบัติกับข้อมูลของท่านในลักษณะที่สอดคล้องกับนโยบายนี้ รวมถึงกฎหมายคุ้มครองข้อมูลส่วนบุคคลด้วย`
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>3.5</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>
                          {trans(
                            `Legal Compliance and Legal Enforcement`,
                            `การดำเนินการตามกฎหมายหรือคำสั่งหน่วยงานรัฐ`
                          )}
                        </p>
                        <p>
                          {trans(
                            `We may be required to disclose your personal information in order to comply with the applicable laws or orders of competent courts or authorities or court orders or other legal processes.`,
                            `เราอาจเปิดเผยข้อมูลของท่านเพื่อปฏิบัติตามกฎหมาย เพื่อการดำเนินคดี การปฏิบัติตามคำสั่งศาล หมายเรียก คำสั่งหน่วยงานรัฐ หรือกระบวนการทางกฎหมายอื่น ๆ  `
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>
                        <p>3.6</p>
                      </LegalOrderingDiv>
                      <div>
                        <p>{trans(`Third Parties`, `บุคคลภายนอก`)}</p>
                        <p>
                          {trans(
                            `We may disclose your personal data to any third parties as per your request and/or as permitted by laws.`,
                            `เราอาจเปิดเผยข้อมูลส่วนบุคคลตามคำร้องขอของท่านให้แก่บุคคลภายนอกหรือตามที่กฎหมายอนุญาต`
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <p>
                      ในกรณีที่เราเปิดเผยข้อมูลส่วนบุคคลของท่านให้บุคคลอื่นหรือมอบหมายให้บุคคลอื่นให้บริการที่เกี่ยวข้องกับธุรกิจของเรา
                      เช่น การให้บริการจัดส่งพัสดุ
                      เราจะกำหนดให้หน่วยงานดังกล่าวดำเนินการเก็บรักษาข้อมูลส่วนบุคคลไว้เป็นความลับและจะจัดให้มีมาตรการที่เหมาะสมเพื่อคุ้มครองข้อมูลส่วนบุคคลที่ได้เปิดเผยและเพื่อปฏิบัติตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่3 */}
                {/* เริ่มหัวข้อที่4 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>4.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Cross-border Data Transfer',
                        'การโอนข้อมูลส่วนบุคคลไปต่างประเทศ'
                      )}
                    </strong>
                    <p>
                      {trans(
                        'We may disclose or transfer your personal data to individuals, organizations, third-party cloud computing systems or servers, which may be located locally or overseas. We will implement security measures to ensure that your personal data is transferred to the destination country with an adequate security measure or as required by law to protect and maintain your personal data.',
                        'เราอาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคล องค์กร ระบบประมวลผลแบบคลาวด์ หรือเซิร์ฟเวอร์ (server) ที่ตั้งอยู่ในประเทศหรือต่างประเทศซึ่งเราได้เข้าทำสัญญา ทั้งนี้ เราจะดำเนินการตามมาตรการต่าง ๆ เพื่อให้มั่นใจว่าการโอนข้อมูลส่วนบุคคลของท่านไปยังประเทศปลายทางนั้นมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลอย่างเพียงพอ หรือกรณีอื่น ๆ ตามที่กฎหมายกำหนด'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่4 */}
                {/* เริ่มหัวข้อที่5 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>5.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Storage of Data',
                        'วิธีการเก็บรักษาข้อมูลส่วนบุคคล'
                      )}
                    </strong>
                    <p>
                      {trans(
                        'Your personal data may be stored in document or electronic form and we will store such personal data on our company’s server in Thailand and/or outside of Thailand.',
                        'เราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านในรูปแบบเอกสารและรูปแบบอิเล็กทรอนิกส์โดยเก็บรักษาข้อมูลส่วนบุคคลของท่านบนเซิร์ฟเวอร์บริษัทของเราในประเทศไทย และ/หรือบนเซิร์ฟเวอร์บริษัทของเราในต่างประเทศ องค์กร ระบบประมวลผลแบบคลาวด์ หรือเซิร์ฟเวอร์ (server) ที่ตั้งอยู่ในประเทศหรือต่างประเทศซึ่งเราได้เข้าทำสัญญา ทั้งนี้ เราจะดำเนินการตามมาตรการต่าง ๆ เพื่อให้มั่นใจว่าการโอนข้อมูลส่วนบุคคลของท่านไปยังประเทศปลายทางนั้นมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลอย่างเพียงพอ หรือกรณีอื่น ๆ ตามที่กฎหมายกำหนด'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่5 */}
                {/* เริ่มหัวข้อที่6 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>6.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Data Retention',
                        'ระยะเวลาจัดเก็บข้อมูลส่วนบุคคล'
                      )}
                    </strong>
                    <p>
                      {trans(
                        'We will retain your personal data for the period you are our customers or under a relationship with us and for the period of 10 years after you stop being our customers or terminate the relationship with us. However, the aforementioned period may be extended in cases where we are required to achieve the purposes related to this Privacy Policy or in cases where we are legally allowed to process such data. After the above period elapses, we will erase, destroy or anonymize your personal data in accordance with our destruction guidelines and legal standards.',
                        'เราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้ตามระยะเวลาที่จำเป็นในระหว่างที่ท่านเป็นผู้ใช้บริการหรือมีความสัมพันธ์อยู่กับเราและเป็นระยะเวลา 10 ปีภายหลังจากที่ท่านไม่ได้ใช้บริการหรือมีความสัมพันธ์กับเรา หรือตลอดระยะเวลาที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ที่เกี่ยวข้องกับนโยบายฉบับนี้ ซึ่งอาจจำเป็นต้องเก็บรักษาไว้ต่อไปภายหลังจากนั้นหรืออาจมากกว่าระยะเวลาดังกล่าวในกรณีที่เรายังสามารถประมวลผลข้อมูลดังกล่าวได้โดยชอบด้วยกฎหมาย โดยเราจะลบ ทำลาย หรือทำให้เป็นข้อมูลที่ไม่สามารถระบุตัวตนของท่านตามขั้นตอนการทำลายข้อมูลของเราหรือตามมาตรฐานที่กฎหมายกำหนด เมื่อหมดความจำเป็นหรือสิ้นสุดระยะเวลาดังกล่าว'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่6 */}
                {/* เริ่มหัวข้อที่7 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>7.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Accuracy of your personal data',
                        'ความถูกต้องของข้อมูลส่วนบุคคลของท่าน'
                      )}
                    </strong>
                    <p>
                      {trans(
                        'To provide up-to-date and efficient services to you and comply with the terms of contracts or agreements, we need your help to ensure that your personal data is current, complete, and accurate. Please inform us of any changes to your personal data or update your information via our websites or applications.',
                        'เพื่อให้การให้บริการหรือการปฏิบัติตามข้อกำหนดของสัญญาหรือข้อตกลงต่าง ๆ เป็นไปอย่างทันสมัยและมีประสิทธิภาพ ท่านจะทำให้ข้อมูลส่วนบุคคลของท่านที่อยู่ในความครอบครองของเรา มีความเป็นปัจจุบัน สมบูรณ์ และถูกต้อง โดยท่านจะแจ้งให้เราทราบเมื่อข้อมูลส่วนบุคคลของท่านมีการเปลี่ยนแปลงหรือท่านสามารถปรับปรุงแก้ไขข้อมูลส่วนบุคคลของท่านได้ด้วยตนเองผ่านเว็บไซต์หรือแอปพลิเคชันของเรา'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่7 */}
                {/* เริ่มหัวข้อที่8 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>8.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Data Subject Rights',
                        'สิทธิเกี่ยวกับข้อมูลส่วนบุคคลของท่าน'
                      )}
                    </strong>
                    <p>
                      {trans(
                        'You may exercise any of these rights in the following:',
                        'ท่านมีสิทธิในการดำเนินการดังต่อไปนี้'
                      )}
                    </p>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8.1</LegalOrderingDiv>
                      <div>
                        {' '}
                        {trans(
                          'Right to withdraw consent: If you have given consent to us to collect, use or disclose your personal data whether before or after the effective date of the PDPA, you have the right to withdraw such consent by managing your privacy in your account or contact us at any time throughout the period your personal data is available to us.',
                          'สิทธิขอถอนความยินยอม (right to withdraw consent) หากท่านได้ให้ความยินยอม เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน ไม่ว่าจะเป็นความยินยอมที่ท่านให้ไว้ก่อนวันที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลใช้บังคับหรือหลังจากนั้น โดยท่านมีสิทธิที่จะถอนความยินยอมเมื่อใดก็ได้ตลอดเวลาผ่านทางเมนูจัดการความเป็นส่วนตัวหรือแจ้งให้เราทราบ'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8.2</LegalOrderingDiv>
                      <div>
                        {' '}
                        {trans(
                          'Right to access: You have the right to access your personal data that is under our responsibility; to request us to make a copy of such data for you, and to request us to reveal how we obtain your personal data.',
                          'สิทธิในการได้รับแจ้งข้อมูล (right to be informed) ท่านมีสิทธิได้รับแจ้งเกี่ยวกับรายละเอียดการเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล ซึ่งรวมถึงวัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคลที่เก็บรวบรวม ระยะเวลาในการเก็บรวบรวม ช่องทางในการติดต่อผู้ควบคุมข้อมูลส่วนบุคคล'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8.3</LegalOrderingDiv>
                      <div>
                        {' '}
                        {trans(
                          'Right to data portability: You have the right to obtain your personal data if we organize such personal data in automatic machine-readable or usable format and can be processed or disclosed by automatic means; to request us to send or transfer the personal data in such format directly to other data controllers if doable by automatic means, and to request to obtain the personal data in such format sent or transferred by us directly to other data controllers unless not technically feasible.',
                          'สิทธิขอเข้าถึงข้อมูล (right to access) ท่านมีสิทธิขอเข้าถึงข้อมูลส่วนบุคคลของท่านที่อยู่ในความรับผิดชอบของเรา และขอให้เราทำสำเนาข้อมูลดังกล่าวให้แก่ท่าน รวมถึงขอให้เราเปิดเผยว่าเราได้ข้อมูลส่วนบุคคลของท่านมาได้อย่างไร'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8.4</LegalOrderingDiv>
                      <div>
                        {' '}
                        {trans(
                          'Right to objection: You have the right to object to the collection, use, or disclosure of your personal data at any time if such doing is conducted for legitimate interests of us, corporation, or individual which is within your reasonable expectation; or for carrying out public tasks.',
                          `สิทธิขอถ่ายโอนข้อมูล (right to data portability) ท่านมีสิทธิขอรับข้อมูลส่วนบุคคลของท่านในกรณีที่เราได้จัดทำข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบให้สามารถอ่านหรือใช้งานได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ รวมทั้งมีสิทธิขอให้เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นเมื่อสามารถทำได้ด้วยวิธีการอัตโนมัติและมีสิทธิขอรับข้อมูลส่วนบุคคลที่เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นโดยตรง เว้นแต่ไม่สามารถดำเนินการได้เพราะเหตุทางเทคนิค`
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8.5</LegalOrderingDiv>
                      <div>
                        {' '}
                        {trans(
                          'Right to erasure or destruction: You have the right to request us to erase, destroy or anonymize your personal data if you believe that the collection, use or disclosure of your personal data is against relevant laws; or retention of the data by us is no longer necessary in connection with related purposes under this Privacy Policy; or when you request to withdraw your consent or to object to the processing as earlier described.',
                          'สิทธิขอคัดค้าน (right to object) ท่านมีสิทธิขอคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านในเวลาใดก็ได้ หากการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านที่ทำขึ้นเพื่อการดำเนินงานที่จำเป็นภายใต้ประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลหรือนิติบุคคลอื่น โดยไม่เกินขอบเขตที่ท่านสามารถคาดหมายได้อย่างสมเหตุสมผลหรือเพื่อดำเนินการตามภารกิจเพื่อสาธารณประโยชน์'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8.6</LegalOrderingDiv>
                      <div>
                        {' '}
                        {trans(
                          'Right to restriction of processing: You have the right to request us to suspend processing your personal data during the period where we examine your rectification or objection request; or when it is no longer necessary, and we must erase or destroy your personal data pursuant to relevant laws, but you request us to suspend the processing instead.',
                          'สิทธิขอให้ลบหรือทำลายข้อมูล (right to erasure/destruction) ท่านมีสิทธิขอลบหรือทำลายข้อมูลส่วนบุคคลของท่านหรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวท่านได้ หากท่านเชื่อว่าข้อมูลส่วนบุคคลของท่านถูกเก็บรวบรวม ใช้ หรือเปิดเผยโดยไม่ชอบด้วยกฎหมายที่เกี่ยวข้อง หรือเห็นว่าเราหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่เกี่ยวข้องในนโยบายฉบับนี้ หรือเมื่อท่านได้ใช้สิทธิขอถอนความยินยอมหรือใช้สิทธิขอคัดค้านตามที่แจ้งไว้ข้างต้นแล้ว'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8.7</LegalOrderingDiv>
                      <div>
                        {' '}
                        {trans(
                          'Right to rectification: You have the right to rectify your personal data to be updated, complete and not misleading.',
                          'สิทธิขอให้ระงับการใช้ข้อมูล (right to restriction of processing) ท่านมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลชั่วคราวในกรณีที่เราอยู่ระหว่างตรวจสอบตามคำร้องขอใช้สิทธิขอแก้ไขข้อมูลส่วนบุคคลหรือขอคัดค้านของท่าน หรือกรณีอื่นใดที่เราหมดความจำเป็นและต้องลบหรือทำลายข้อมูลส่วนบุคคลของท่านตามกฎหมายที่เกี่ยวข้องแต่ท่านขอให้เราระงับการใช้แทน'
                        )}
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>8.8</LegalOrderingDiv>
                      <div>
                        {' '}
                        {trans(
                          'Right to lodge a complaint: You have the right to complain to competent authorities pursuant to relevant laws if you believe that the collection, use, or disclosure of your personal data is violating or not in compliance with relevant laws.',
                          'สิทธิขอให้แก้ไขข้อมูล (right to rectification) ท่านมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด'
                        )}
                      </div>
                    </LegalStyleDiv>
                    {!isEnglish && (
                      <LegalStyleDiv>
                        <LegalOrderingDiv>8.9</LegalOrderingDiv>
                        <div>
                          {`สิทธิร้องเรียน (right to lodge a complaint) ท่านมีสิทธิร้องเรียนต่อผู้มีอำนาจตามกฎหมายที่เกี่ยวข้อง หากท่านเชื่อว่าเราเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านเป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง`}
                        </div>
                      </LegalStyleDiv>
                    )}
                    <p>
                      {trans(
                        'You may exercise these rights as the data subject by contacting SHIPPOP through the communication channel as set out below. We will notify the result of your request within 30 days upon the receipt of such request. If we deny the request, we will notify you via SMS, email, phone, or registered mail with the reason for such denial.',
                        'ท่านสามารถใช้สิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคลข้างต้นได้ โดยติดต่อมาที่ชิปป๊อปตามรายละเอียดท้ายนโยบายนี้ ทั้งนี้ หากเราปฏิเสธคำขอเราจะแจ้งเหตุผลของการปฏิเสธให้ท่านทราบภายใน 30 วันผ่านช่องทางต่าง ๆ เช่น ข้อความ (SMS) อีเมล โทรศัพท์ จดหมาย เป็นต้น'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่8 */}
                {/* เริ่มหัวข้อที่9 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>9.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Right to control your personal data',
                        'การควบคุมข้อมูลส่วนบุคคลของท่าน'
                      )}
                    </strong>
                    <p>
                      {trans(
                        'For the benefit of maintaining your privacy, it is your right to grant your consent to allow us to use or share your personal data. You may choose to receive any specific information, promotions or any marketing materials related to our services or products from the SHIPPOP by filling in the request to notify SHIPPOP.',
                        'เพื่อประโยชน์ในการรักษาความเป็นส่วนตัวของท่านและภายใต้ความยินยอมของท่าน ท่านมีสิทธิเลือกที่จะให้มีการใช้หรือแชร์ข้อมูลส่วนบุคคลของท่านหรืออาจเลือกที่จะปฏิเสธไม่รับข้อมูล โปรโมชั่น หรือสื่อทางการตลาดใด ๆ จากบริการหรือสินค้าของชิปป๊อปก็ได้ เพียงแต่ท่านกรอกความจำนงดังกล่าวเพื่อแจ้งให้ชิปป๊อปทราบ'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่9 */}
                {/* เริ่มหัวข้อที่10 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>10.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Personal Data Security Measures',
                        'การรักษาความมั่นคงปลอดภัยสำหรับข้อมูลส่วนบุคคล'
                      )}
                    </strong>
                    <p>
                      {trans(
                        'To maintain confidentiality and security of your personal data, we have established internal regulations to determine the right of access or to use your personal data and for the purpose of confidentiality and security in certain information such as credit card number, a front page of a bankbook, previous bank statement, etc. We also provide a secure communication channel for such information by encrypting the information such as providing a Secure Socket Layer (SSL) protocol.  Furthermore, we strive to protect your personal data by implementing security measures that adhere to the principles of confidentiality, integrity, and availability in order to prevent loss, unauthorized or unlawful access, destruction, use, alteration, modification, or disclosure. Further, in order to protect and secure your personal information, we will maintain your personal information no less than the standard prescribed by applicable laws and regulations.',
                        'เพื่อประโยชน์ในการรักษาความลับและความปลอดภัยสำหรับข้อมูลส่วนบุคคลของท่าน เราจึงได้กำหนดระเบียบภายในหน่วยงานเพื่อกำหนดสิทธิในการเข้าถึงหรือใช้ข้อมูลส่วนบุคคลของท่าน และเพื่อรักษาความลับ และความปลอดภัยของข้อมูลบางอย่างที่มีความสำคัญอย่างยิ่ง เช่น หมายเลขบัตรเครดิต หน้าบัญชีธนาคาร เป็นต้น นอกจากนี้เราจัดให้มีช่องทางการสื่อสารแบบปลอดภัยสำหรับข้อมูลดังกล่าวด้วยการเข้ารหัสลับข้อมูลดังกล่าว เช่น จัดให้มีการใช้ Secure Socket Layer (SSL) protocol เป็นต้น นอกจากนี้เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข หรือเปิดเผย เราได้จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลด้วยมาตรการที่ไม่น้อยกว่าระดับที่กฎหมายกำหนด'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่10 */}
                {/* เริ่มหัวข้อที่11 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>11.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans('Cookies', 'การใช้คุกกี้ (Cookies)')}
                    </strong>
                    <p>
                      {trans(
                        `“Cookies” are text files with small pieces of information that are stored on your device's browser while you are connecting to the internet or surfing a website. We may use cookies or other similar analytical tools for your comfort in surfing our platforms, security, service assessment and improvement, and statistical analysis. You can block some types of cookies on your browser setting. However, blocking some types of cookies may impact your experience of our platforms and the services we are able to offer.`,
                        'คุกกี้ คือ ไฟล์ข้อความขนาดเล็กที่อยู่ในคอมพิวเตอร์ของท่านเมื่อท่านใช้งานอินเตอร์เน็ตหรือเมื่อท่านเข้าเยี่ยมชมเว็บไซต์ โดยเราอาจใช้งานคุกกี้หรือเทคโนโลยีอื่นที่คล้ายกันเพื่อการเข้าสู่ระบบของท่านอย่างต่อเนื่อง การรักษาความปลอดภัย การพัฒนาการให้บริการของชิปป๊อปให้มีประสิทธิภาพ การประเมินการใช้บริการของท่าน และการวิเคราะห์เชิงสถิติ โดยท่านสามารถตั้งค่าเบราว์เซอร์มิให้ใช้งานคุกกี้หรือเครื่องมื่ออืน ๆ ด้วยตนเอง ทั้งนี้ การปิดหรือจำกัดการใช้งานคุกกี้อาจทำให้ท่านไม่สามารถใช้แพลตฟอร์มหรือบริการของชิปป๊อปได้อย่างเต็มที่'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่11 */}
                {/* เริ่มหัวข้อที่11.1 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>11.1</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>{trans('Types Of Cookies', 'ประเภทคุกกี้')}</strong>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>1)</LegalOrderingDiv>
                      <div>
                        {trans(
                          'Strictly Necessary Cookies',
                          'คุกกี้ที่มีความจำเป็นอย่างยิ่ง (Strictly Necessary Cookies)'
                        )}
                        <p>
                          {trans(
                            `Strictly Necessary cookies are very essential to the platforms as these allow the platforms to respond to your actions, support the material structure of the page being displayed to verify your identity and prevent user impersonation. Therefore, we need to use these cookies to provide our services to you.`,
                            `คุกกี้เหล่านี้มีความสำคัญต่อการให้บริการบนแพลตฟอร์มแก่ท่านและทำให้ท่านสามารถใช้คุณลักษณะที่สำคัญได้ คุกกี้เหล่านี้จะช่วยในด้านการยืนยันตัวบุคคลของผู้ใช้งานและช่วยป้องกันการปลอมแปลงบัญชีผู้ใช้งาน หากไม่มีคุกกี้เหล่านี้เราจะไม่สามารถให้บริการแก่ท่านได้ เราจึงจำเป็นต้องใช้คุกกี้ดังกล่าวนี้เพื่อให้บริการแก่ท่าน`
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>2)</LegalOrderingDiv>
                      <div>
                        {trans(
                          'Functional Cookies',
                          'คุกกี้เพื่อการทำงานของเว็บไซต์ (Functional Cookies)'
                        )}
                        <p>
                          {trans(
                            `Functional cookies help us to recognise when you revisit the platforms such as your latest shipment order. With this information, we can provide enhanced and more personalized features to facilitate your visit, as well as provide convenience to you when you fill in any information on your next visit. You can control or delete these cookies by cookies management on your browser settings.`,
                            `คุกกี้เหล่านี้ช่วยให้เราสามารถจดจำสิ่งที่ท่านเลือกเมื่อใช้งานแพลตฟอร์ม เช่น การจดจำข้อมูลการสร้างขนส่งครั้งล่าสุดของคุณ โดยคุกกี้เหล่านี้เป็นคุกกี้แบบถาวรซึ่งจะทำให้ท่านได้รับประสบการณ์ที่สะดวกต่อการใช้งานและอำนวยความสะดวกในการกรอกข้อมูลเมื่อท่านใช้งานแพลตฟอร์มในครั้งต่อไป ในกรณีที่ท่านไม่ประสงค์จะใช้งานคุกกี้ประเภทนี้ต่อไป ท่านสามารถลบคุกกี้เหล่านี้ผ่าน Browser ของท่านได้ด้วยตนเอง`
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>3)</LegalOrderingDiv>
                      <div>
                        {trans(
                          'Analytical/Performance Cookies',
                          'คุกกี้เพื่อการวิเคราะห์/เพื่อประสิทธิภาพ (Analytical/Performance Cookies)'
                        )}
                        <p>
                          {trans(
                            `Analytical / Performance cookies allow us to monitor the performance of our websites by determining the number of page views and the number of unique users a website has. We use that information to enhance user experience or identify areas of the platforms which may require improvement.`,
                            `คุกกี้เหล่านี้ช่วยให้เราจดจำและนับจำนวนผู้ใช้งานบนแพลตฟอร์มของเรา รวมถึงทำให้เราเข้าใจถึงวิธีการที่ผู้ใช้งานใช้งานบนเว็บไซต์ของเรา สิ่งเหล่านี้จะช่วยปรับปรุงวิธีการทำงานของแพลตฟอร์มและทำให้มั่นใจว่าผู้ใช้งานสามารถค้นหาสิ่งที่ต้องการได้ง่ายขึ้น`
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                    <LegalStyleDiv>
                      <LegalOrderingDiv>4)</LegalOrderingDiv>
                      <div>
                        {trans(
                          'Advertising Cookies',
                          `คุกกี้เพื่อการโฆษณา (Advertising Cookies)`
                        )}
                        <p>
                          {trans(
                            `Advertising cookies will be placed on your device to record your visit, the page and the link you have visited and followed. The gained information will be used to assess our marketing performance effectiveness and offer our advertising campaign to suit your interests. These cookies may be shared with our business partners if we have already obtained your consent.`,
                            `คุกกี้ประเภทนี้จะจดจำการเข้าหน้าเว็บไซต์ จุดเยี่ยมชมและสนใจของท่านเพื่อแสดงโฆษณาที่เกี่ยวข้องกับท่าน โดยคุกกี้นี้จะช่วยให้เราสามารถประเมินประสิทธิภาพด้านการตลาด และนำเสนอโฆษณาที่ท่านอาจสนใจ ในการใช้คุกกี้นี้เราอาจแบ่งปันข้อมูลนี้กับบุคคลที่สามซึ่งเป็นพันธมิตรทางธุรกิจของเราภายใต้ความยินยอมของท่าน`
                          )}
                        </p>
                      </div>
                    </LegalStyleDiv>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่11.1 */}
                {/* เริ่มหัวข้อที่11.2 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>11.2</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans('Cookies Setting', 'การจัดการ Cookies')}
                    </strong>

                    {isEnglish ? (
                      <p>
                        Cookies can be blocked from your browser used to surf
                        our website. You can manage Cookies through “Cookies
                        Setting” on our platforms or via
                        <span
                          className={classes.highlight}
                          onClick={handleClickSetCookies}
                        >
                          &nbsp;setting
                        </span>
                      </p>
                    ) : (
                      <p>
                        ท่านสามารถต้ังค่ามิให้ Browser ของท่านตกลงรับ Cookies
                        ของเราได้โดยเลือกที่เมนูตั้งค่าคุกกี้บนแพลตฟอร์มของเรา
                        หรือที่
                        <span
                          className={classes.highlight}
                          onClick={handleClickSetCookies}
                        >
                          &nbsp;จัดการความเป็นส่วนตัว
                        </span>
                      </p>
                    )}
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่11.2 */}
                {/* เริ่มหัวข้อที่12 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>12.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Data Breach Notification',
                        'การแจ้งเหตุละเมิดข้อมูลส่วนบุคคล'
                      )}
                    </strong>
                    <p>
                      {trans(
                        `In case of a data breach incident, we will notify the Office of the Personal Data Protection Committee without delay and, where feasible, within 72 hours after having become aware of it. If the personal data breach is likely to result in a high risk to your rights and freedoms of you, we will also notify the personal data breach and the remedial measures to you as soon as possible through channels such as our websites, SMS, email address, telephone, or registered mail.`,
                        'ในกรณีที่มีเหตุละเมิดข้อมูลส่วนบุคคลของท่านเกิดขึ้น เราจะแจ้งให้สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลทราบโดยไม่ชักช้าภายใน 72 ชั่วโมง นับแต่ทราบเหตุเท่าที่สามารถกระทำได้ ในกรณีที่การละเมิดมีความเสี่ยงสูงที่จะมีผลกระทบต่อสิทธิและเสรีภาพของท่าน เราจะแจ้งการละเมิดให้ท่านทราบพร้อมกับแนวทางการเยียวยาโดยไม่ชักช้าผ่านช่องทางต่าง ๆ เช่น เว็บไซต์ ข้อความ (SMS) อีเมล โทรศัพท์ จดหมาย เป็นต้น'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่12 */}
                {/* เริ่มหัวข้อที่13 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>13.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans(
                        'Privacy Policy Amendment',
                        'การปรับปรุงนโยบายความเป็นส่วนตัว'
                      )}
                    </strong>
                    <p>
                      {trans(
                        `SHIPPOP reserves the right to amend this Privacy Policy without any prior notice for improving appropriation and efficiency in providing services, or in order to ensure compliance with the relevant laws. We recommend you read and understand the Privacy Policy at the time you use the services or access our platforms. Your continued use of our Services after such an amendment will mean that you accept those amendments. `,
                        'ชิปป๊อปอาจทำการปรับปรุงหรือแก้ไขนโยบายความเป็นส่วนตัวนี้เพื่อความเหมาะสมหรือสอดคล้องกับการเปลี่ยนแปลงของการให้บริการและการดำเนินงานของเรา หรือ เพื่อให้เป็นไปตามบทบัญญัติของกฎหมายที่เกี่ยวข้อง เราจึงขอแนะนำให้ท่านอ่านนโยบายความเป็นส่วนตัวทุกครั้งที่เยี่ยมชมแพลตฟอร์มหรือใช้บริการของเรา การที่ท่านใช้แพลตฟอร์มหรือบริการของเราต่อไปภายหลังที่ได้มีการแจ้งถึงการเปลี่ยนแปลงดังกล่าวแล้ว ถือว่าท่านยอมรับการแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัว ทั้งนี้ เราอาจขอความยินยอมจากท่านเพิ่มเติม หากกฎหมายที่ใช้บังคับกำหนดไว้'
                      )}
                    </p>
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่13 */}
                {/* เริ่มหัวข้อที่14 */}
                <LegalStyleDiv>
                  <LegalOrderingDiv>
                    <strong>14.</strong>
                  </LegalOrderingDiv>
                  <div>
                    <strong>
                      {trans('Communication Channel', 'ช่องทางการติดต่อ')}
                    </strong>
                    <p>
                      {trans(
                        `If you have any questions or wish to exercise your right in accordance with this Privacy Policy, you can contact us through the following channels:`,
                        'ในกรณีที่ท่านมีข้อสงสัย ข้อเสนอแนะ หรือข้อติชมใดๆ เกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้หรือต้องการใช้สิทธิใด ๆ เรายินดีที่จะตอบข้อสงสัยรับฟังข้อเสนอแนะและคำติชมทั้งหลายอันจะเป็นประโยชน์ต่อการปรับปรุงการ ให้บริการของชิปป๊อปต่อไป โดยท่านสามารถติดต่อกับเราผ่านช่องทางดังนี้'
                      )}
                    </p>
                    {isEnglish ? (
                      <div>
                        <p style={{ margin: '0' }}>Shippop Company Limited​</p>
                        <p style={{ margin: '0' }}>
                          Address: No.34 C.P.Tower 3 Building, Room No. A04-402, 4th Floor,
                        </p>
                        <p style={{ margin: '0' }}>
                          Phayathai road, Thung Phayathai Sub-district, Ratchathewi District, Bangkok 10400
                        </p>
                        <p style={{ margin: '0' }}>
                          Taxpayer Identification Number: 0105558183739
                        </p>
                        <p style={{ margin: '0' }}>
                          Email: cs@shippop.com
                        </p>
                        <p style={{ margin: '0' }}>
                          websites: https://www.shippop.com
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p style={{ margin: '0' }}>
                          บริษัท​ ชิปป๊อป​ จำกัด​ (สำนักงานใหญ่)
                        </p>
                        <p style={{ margin: '0' }}>
                          เลขที่ 34 อาคารซี.พี.ทาวเวอร์ 3 ห้องเลขที่ A04-402 ชั้นที่ 4
                        </p>
                        <p style={{ margin: '0' }}>
                          ถนนพญาไท แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400
                        </p>
                        <p style={{ margin: '0' }}>อีเมล cs@shippop.com</p>
                        <p style={{ margin: '0' }}>
                          เว็บไซต์ https://www.shippop.com
                        </p>
                      </div>
                    )}
                  </div>
                </LegalStyleDiv>
                {/* จบหัวข้อที่14 */}
              </>

              <ConsentUpdateDetail isEnglish={isEnglish} />
            </Paper>
          </Container>
        </div>

        <PdpaPopup
          isShowing={isPdpaShowing}
          setShowing={setPdpaShowing}
          pdpaStates={pdpaStates}
          setPdpa={setPdpa}
          isLoggedIn={
            // Harden the existing SSR guard: this dev env exposes a `localStorage`
            // global that is defined but has no getItem, so `typeof localStorage
            // !== 'undefined'` alone still threw during SSR and 500'd BOTH
            // /privacy and /privacy?new. Checking getItem is a function keeps the
            // browser behaviour identical while making SSR safe (pre-existing bug
            // surfaced when wiring the ?new variant; not a logic change).
            typeof localStorage !== 'undefined' &&
            typeof localStorage.getItem === 'function'
              ? localStorage.getItem('jwt_token')
              : false
          }
          editCookiesMode={editCookiesMode}
          setEditCookiesMode={setEditCookiesMode}
        />
        <MascotBox />
      </>
  )

  // ?new: new-design chrome (NewShell provides Layout + HeaderNew + FooterNew).
  if (isNew) {
    return <NewShell {...META}>{content}</NewShell>
  }

  // Default (no ?new): original chrome, unchanged.
  return (
    <div className={classes.root}>
      <Layout {...META}>{content}</Layout>
    </div>
  )
}

export default Privacy
